import { Ribbon } from '@tempmee/react';
import { SolidExclamationWarningAlertIcon } from '@tempmee/react-icons';
import history from '~/browserHistory';
import { routes } from '~/routes';
import { usePendingAchBannerVisible } from './usePendingAchBannerVisible';

interface IPendingAchVerificationBannerProps {
  containerStyle?: React.CSSProperties;
  dataCy?: string;
}

export const PendingAchVerificationBanner = ({
  containerStyle,
  dataCy = 'pending-ach-warning',
}: IPendingAchVerificationBannerProps) => {
  const isVisible = usePendingAchBannerVisible();

  if (!isVisible) {
    return null;
  }

  return (
    <Ribbon
      data-cy={dataCy}
      variant="soft-warning"
      Icon={SolidExclamationWarningAlertIcon}
      role="button"
      tabIndex={0}
      onClick={() => history.push(routes.paymentInformation)}
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          history.push(routes.paymentInformation);
        }
      }}
      style={{
        cursor: 'pointer',
        marginBottom: 0,
        ...containerStyle,
      }}
    >
      Bank Account Pending. Confirm deposit now
    </Ribbon>
  );
};
